/*
 * Sampo navigation v2: desktop mega menu + "Apua" button (>= 1200 px, [data-sampo-mega]) and the mobile
 * drill-down drawer (< 1200 px, nav#mobile-nav.sampo-dd driven by the theme's #open-mobile-nav checkbox).
 * Markup: snippets/sampo-mega-menu.liquid, sampo-nav-help.liquid, sampo-mobile-drawer.liquid. Loaded with defer
 * by layout/theme.liquid only when the gate snippets/sampo-nav-on.liquid is on. Plain JavaScript, no dependencies.
 * The mega menu part moved here from assets/sampo-catalog.js (audit 28.9b M3).
 */
(function () {
  'use strict';
  if (window.SampoNav) return;
  var SN = window.SampoNav = { version: '2026-09-29' };
  var doc = document;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), ' +
    'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function all(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function up(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function focusEl(el) {
    if (!el || !el.focus) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function mq(q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; }
  function onMq(m, fn) {
    if (m.addEventListener) m.addEventListener('change', fn);
    else if (m.addListener) m.addListener(fn);
  }

  /* ------------------------------------------------------ photo warm-up (no effect on page load) */
  // The menu photos are lazy, so nothing of the menu loads with the page. Opening a panel then waited for its
  // photos (owner 29.9.2026). Now the photos are fetched into the cache at low priority on intent: desktop when
  // the pointer comes to the header or focus enters the menu (every panel), phones in idle time after load (only
  // the drawer's small first level) and when the drawer opens (the levels behind it), plus a pressed drawer row.
  // A detached Image with the same sizes + srcset picks the same file the real <img> will use. Skipped with data
  // saver or a 2g connection (Chrome; Safari has no navigator.connection).
  var warmed = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function slowNet() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }
  function warm(root) {
    if (!root || slowNet()) return;
    all('img', root).forEach(function (img) {
      if (!warmed || warmed.has(img)) return;
      warmed.add(img);
      var src = img.getAttribute('src');
      if (!src) return;
      var pre = new Image();
      pre.decoding = 'async';
      try { pre.fetchPriority = 'low'; } catch (e) { /* older browsers */ }
      if (img.getAttribute('sizes')) pre.sizes = img.getAttribute('sizes');
      if (img.getAttribute('srcset')) pre.srcset = img.getAttribute('srcset');
      pre.src = src;
    });
  }
  function whenIdle(fn) {
    function go() {
      if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 3000 });
      else setTimeout(fn, 1200);
    }
    if (doc.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  }

  /* --------------------------------------------------------------- mega menu + "Apua" (desktop) */
  var navs = [];

  function initMega(nav) {
    if (nav.sampoReady) return;
    nav.sampoReady = true;
    navs.push(nav);
    var items = all('[data-sampo-mega-item]', nav);
    var hover = mq('(hover: hover) and (pointer: fine)');
    var timer = null;

    function panel(it) { return it.querySelector('[data-sampo-mega-panel]'); }
    function toggle(it) { return it.querySelector('[data-sampo-mega-toggle]'); }
    function hide(it) {
      var p = panel(it);
      var b = toggle(it);
      if (!p) return;
      p.hidden = true;
      it.classList.remove('is-open');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    function show(it) {
      navs.forEach(function (n) { if (n !== nav && n.sampoHideAll) n.sampoHideAll(); });
      items.forEach(function (o) { if (o !== it) hide(o); });
      var p = panel(it);
      var b = toggle(it);
      if (!p) return;
      p.hidden = false;
      // never taller than the window below the header: max-height: calc(100vh - var(--sampo-mega-top)),
      // the rest scrolls inside the panel (assets/sampo-nav.css)
      p.style.setProperty('--sampo-mega-top', Math.max(0, Math.round(p.getBoundingClientRect().top)) + 'px');
      it.classList.add('is-open');
      if (b) b.setAttribute('aria-expanded', 'true');
    }
    nav.sampoHideAll = function () { clearTimeout(timer); items.forEach(hide); };

    // desktop only (a phone never shows these panels): every panel's photos as soon as the pointer comes to the
    // header or focus enters the menu, an intent signal a moment before a panel opens. Visitors who never go near
    // the menu load nothing (audit 29.9.2026 SUO-3 / KOODI-6: the idle-time warm-up cost every desktop visit
    // 0.2-0.5 MB). warm() skips photos it already fetched.
    function warmAll() { if (mq('(min-width: 1200px)').matches) items.forEach(function (it) { warm(panel(it)); }); }
    (up(nav, 'header') || up(nav, '.page__header') || nav).addEventListener('pointerenter', warmAll);
    nav.addEventListener('focusin', warmAll);

    items.forEach(function (it) {
      var b = toggle(it);
      it.addEventListener('pointerenter', function () { warm(panel(it)); });
      if (b) b.addEventListener('focus', function () { warm(panel(it)); });
      it.addEventListener('mouseenter', function () {
        if (!hover.matches) return;
        clearTimeout(timer);
        // hover intent (owner 7.10.2026): a closed menu opens after 200 ms, so a pointer crossing the menu bar does not
        // drop a panel over the page; moving from one open panel to the next stays quick (90 ms)
        var wait = items.some(function (o) { return o.classList.contains('is-open'); }) ? 90 : 200;
        timer = setTimeout(function () {
          if (panel(it)) { show(it); it.sampoHoverAt = Date.now(); } else items.forEach(hide);
        }, wait);
      });
      it.addEventListener('mouseleave', function () {
        if (!hover.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { hide(it); }, 260);
      });
      if (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          clearTimeout(timer);
          // a click that lands right after the hover opened the panel means "open", not "close" (koodi L1)
          if (it.classList.contains('is-open')) {
            if (Date.now() - (it.sampoHoverAt || 0) > 400) hide(it);
          } else {
            show(it);
          }
          it.sampoHoverAt = 0;
        });
      }
      it.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && it.classList.contains('is-open')) {
          hide(it);
          if (b) b.focus();
        }
      });
      it.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !it.contains(e.relatedTarget)) hide(it);
      });
    });
    doc.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) items.forEach(hide);
    });
  }

  /* ------------------------------------------------------------ mobile drill-down drawer */
  function initDrawer() {
    var nav = doc.getElementById('mobile-nav');
    var cb = doc.getElementById('open-mobile-nav');
    if (!nav || !cb || !nav.classList.contains('sampo-dd') || nav.sampoReady) return;
    nav.sampoReady = true;
    var root = nav.querySelector('[data-sampo-dd-root]');
    var back = nav.querySelector('[data-sampo-dd-back]');
    var closer = nav.querySelector('.sampo-dd__close');
    var bar = nav.querySelector('.sampo-dd__bar');
    var burger = doc.querySelector('.mobile-submenu-label[for="open-mobile-nav"]');
    var cur = null;
    var opener = null;
    var touchY = null;

    function openSub(btn) {
      var sec = doc.getElementById(btn.getAttribute('aria-controls'));
      if (!sec) return;
      if (cur) closeSub(false);
      cur = sec;
      opener = btn;
      if (sec.hidden) {
        // first visit: display the level (its lazy images start loading), then let it slide in
        sec.hidden = false;
        void sec.offsetWidth;
      }
      sec.scrollTop = 0;
      sec.classList.add('is-active');
      if (root) root.classList.add('is-behind');
      nav.classList.add('is-sub');
      if (back) back.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      focusEl(sec.querySelector('h2'));
    }

    function closeSub(focus) {
      if (!cur) return;
      var o = opener;
      cur.classList.remove('is-active');
      if (root) root.classList.remove('is-behind');
      nav.classList.remove('is-sub');
      if (back) back.hidden = true;
      if (o) o.setAttribute('aria-expanded', 'false');
      cur = null;
      opener = null;
      if (focus) focusEl(o);
    }

    // Scroll lock while open: overflow hidden on <body> (sampo-nav.css; the header script does it too), plus a touch guard for iOS
    // Safari, which scrolls the page through overflow: hidden (the same approach as the theme's minicart:
    // the page never changes position). Touches that would scroll anything but a drawer level at its
    // scrollable range are cancelled.
    function onTouchStart(e) {
      touchY = e.touches && e.touches.length === 1 ? e.touches[0].clientY : null;
    }
    function onTouchMove(e) {
      if (!cb.checked || !e.cancelable) return;
      if (!e.touches || e.touches.length !== 1) return; // pinch zoom stays free
      var lvl = up(e.target, '.sampo-dd__lvl');
      if (!lvl || !nav.contains(lvl)) { e.preventDefault(); return; }
      var y = e.touches[0].clientY;
      var dy = touchY === null ? 0 : y - touchY;
      touchY = y;
      var canScroll = lvl.scrollHeight > lvl.clientHeight + 1;
      var atTop = lvl.scrollTop <= 0;
      var atBottom = Math.ceil(lvl.scrollTop + lvl.clientHeight) >= lvl.scrollHeight - 1;
      if (!canScroll || (dy > 0 && atTop) || (dy < 0 && atBottom)) e.preventDefault();
    }
    function lock(on) {
      doc.documentElement.classList.toggle('sampo-dd-lock', on);
      if (on) {
        doc.addEventListener('touchstart', onTouchStart, { passive: true });
        doc.addEventListener('touchmove', onTouchMove, { passive: false });
      } else {
        doc.removeEventListener('touchstart', onTouchStart, { passive: true });
        doc.removeEventListener('touchmove', onTouchMove, { passive: false });
      }
    }

    // Shopify's cookie banner (first visit) is fixed over the bottom of the screen: the drawer levels get bottom
    // padding of its height, so their last rows scroll above it (audit 29.9.2026 UX-5); 0 once it is answered
    function bannerPad() {
      var b = doc.getElementById('shopify-pc__banner');
      var h = 0;
      if (b && b.getClientRects().length) {
        var r = b.getBoundingClientRect();
        if (r.height > 0 && r.top < window.innerHeight) h = Math.round(window.innerHeight - r.top);
      }
      nav.style.setProperty('--sampo-dd-banner', h + 'px');
    }
    doc.addEventListener('visitorConsentCollected', function () { setTimeout(bannerPad, 400); });
    window.addEventListener('resize', function () { if (cb.checked) bannerPad(); });

    var state = null; // last synced open state (null = not synced yet: no focus moves on page load)
    function sync() {
      var open = cb.checked;
      var a = doc.activeElement;
      var focusInside = !a || a === doc.body || nav.contains(a);
      // closed = inert + aria-hidden (the header's script does the same; set here too so that focus can move
      // in at once, whichever change listener runs first)
      nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) nav.removeAttribute('inert'); else nav.setAttribute('inert', '');
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open === state) return;
      var was = state;
      state = open;
      if (open) {
        nav.classList.add('sampo-dd--seen'); // first-level photos load from the first opening on
        bannerPad();
        warm(root);
        // the levels behind the rows: fetched while the visitor looks at the first level
        whenIdle(function () { all('[data-sampo-dd-open]', nav).forEach(function (b) { warm(doc.getElementById(b.getAttribute('aria-controls'))); }); });
        lock(true);
        focusEl(closer);
      } else {
        closeSub(false);
        if (root) root.scrollTop = 0;
        lock(false);
        if (was === true && focusInside && burger) focusEl(burger);
      }
    }
    function closeDrawer() {
      if (!cb.checked) return;
      cb.checked = false;
      var ev;
      try { ev = new Event('change', { bubbles: true }); } catch (err) {
        ev = doc.createEvent('Event');
        ev.initEvent('change', true, false);
      }
      cb.dispatchEvent(ev);
    }

    cb.addEventListener('change', sync);
    all('[data-sampo-dd-open]', nav).forEach(function (b) {
      // a press starts the level's photos before the click (and the slide) happens
      b.addEventListener('pointerdown', function () { warm(doc.getElementById(b.getAttribute('aria-controls'))); });
      b.addEventListener('click', function () { openSub(b); });
    });
    // phones: the first level's small photos in idle time after load, so the drawer opens with them
    whenIdle(function () { if (!mq('(min-width: 1200px)').matches) warm(root); });
    if (back) back.addEventListener('click', function () { closeSub(true); });
    // the search "field" opens the header's search panel, so the field and the suggestions are the magnifier's (owner
    // 7.10.2026). The drawer closes first: its scroll lock and iOS touch guard would hold the panel's results. The
    // magnifier's own handler (Booster openSearch) focuses the panel's field during this tap, which iOS needs for the
    // keyboard. No panel (the theme's script missing): the search page.
    var search = nav.querySelector('[data-sampo-dd-search]');
    if (search) {
      search.addEventListener('click', function () {
        var icon = doc.querySelector('.page__header--mobile .search__icon') || doc.querySelector('.search__icon');
        var box = doc.querySelector('[data-search-container]');
        closeDrawer();
        if (icon) icon.click();
        if (!box || !box.classList.contains('focused')) {
          window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'search';
        }
      });
    }
    // label[role=button] (hamburger, close X): Enter / Space like a button
    all('label[role="button"][for="open-mobile-nav"]').forEach(function (l) {
      l.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); l.click(); }
      });
    });

    function focusables() {
      var out = [];
      [bar, cur || root].forEach(function (s) { if (s) out = out.concat(all(FOCUSABLE, s)); });
      return out.filter(function (el) { return el.getClientRects().length > 0; });
    }
    doc.addEventListener('keydown', function (e) {
      if (!cb.checked) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        // one level back, then close
        e.preventDefault();
        if (cur) closeSub(true); else closeDrawer();
        return;
      }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      var a = doc.activeElement;
      if (!nav.contains(a)) { e.preventDefault(); focusEl(first); return; }
      if (e.shiftKey && a === first) { e.preventDefault(); focusEl(last); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); focusEl(first); }
    });

    // the drawer only exists below 1200 px: growing the window past it closes the drawer (no stuck lock)
    onMq(mq('(min-width: 1200px)'), function (m) { if (m.matches) closeDrawer(); });
    // back / forward (audit 29.9.2026 UX-4): leaving closes the drawer, so the back-forward cache keeps the page
    // closed; a restored page, or a checkbox state the browser restored on a history visit, never opens it again
    window.addEventListener('pagehide', function () { if (cb.checked) closeDrawer(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted && cb.checked) closeDrawer(); else sync(); });
    var navType = '';
    try { navType = ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {}).type || ''; } catch (err) { /* old browsers */ }
    if (navType === 'back_forward' && cb.checked) cb.checked = false;
    sync();
    SN.closeDrawer = closeDrawer;
  }

  /* -------------------------------------------------------------- init */
  function init() {
    all('[data-sampo-mega]').forEach(initMega);
    initDrawer();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) navs.forEach(function (n) { if (n.sampoHideAll) n.sampoHideAll(); });
  });
  /* ----------------------------------------------------------- menu clicks -> GA4 (owner 29.9.2026) */
  // One event per followed menu link: which menu (mega / help / drawer) and the link's public path. No personal
  // data; the same GA4 tag and consent mode as the theme's other events (faq_open). Read by
  // research/audit-2026-09-29-golive/baseline/mittaus.py (event nav_click, event_category, event_label).
  // The collection rail's links (owner 7.10.2026) are a separate event, rail_click (category back = the "‹ Kaikki …" /
  // parent pills, tile, chip), so the menu's nav_click totals in Sampo's brain stay comparable. Only on a click.
  doc.addEventListener('click', function (e) {
    var a = up(e.target, 'a[href]');
    if (!a || typeof window.gtag !== 'function') return;
    var ev = 'nav_click';
    var area = up(a, '.sampo-dd') ? 'drawer' : (up(a, '.sampo-help') ? 'help' : (up(a, '[data-sampo-mega]') ? 'mega' : null));
    if (!area && up(a, '.sampo-rail')) {
      ev = 'rail_click';
      area = up(a, '.sampo-chip--up') ? 'back' : (up(a, '.sampo-tile') ? 'tile' : 'chip');
    }
    if (!area) return;
    var path;
    try { path = new URL(a.href, window.location.href).pathname; } catch (err) { return; }
    try { window.gtag('event', ev, { event_category: area, event_label: path, transport_type: 'beacon' }); } catch (err) { /* never block the link */ }
  }, true);

  // the mega menu only exists from 1200 px: narrowing the window below it closes an open panel, so no hidden
  // panel stays aria-expanded and reopens when the window widens again (audit 29.9.2026 KOODI-13)
  onMq(mq('(max-width: 1199px)'), function (m) {
    if (m.matches) navs.forEach(function (n) { if (n.sampoHideAll) n.sampoHideAll(); });
  });
  doc.addEventListener('shopify:section:load', init);
})();
